<ts-dialog [title]="selectedFile.name" [showFooter]="false" [drawerStyle]="true" (closeDialog)="discard()">
  <div class="view-file" ts-dialog-body>
    <div
      class="view-file__preview"
      [ngClass]="{
        'view-file__preview--expanded': expandRightSidebar,
        'view-file__preview--collapsed': !expandRightSidebar,
      }"
    >
      @if (selectedFile) {
        @if (selectedFile.wopi && !selectedFile.wopi.errors && editWopiFile) {
          <form
            [action]="selectedFile?.wopi?.edit_url || selectedFile?.wopi?.view_url"
            class="view-file__office-form"
            id="officeForm"
            method="post"
            name="officeForm"
            target="officeFrame"
          >
            <input [value]="selectedFile?.wopi?.access_token" name="access_token" type="hidden" />
            <input [value]="selectedFile?.wopi?.access_token_ttl" name="access_token_ttl" type="hidden" />
            <input [value]="selectedFile?.wopi?.owner_id" name="owner_id" type="hidden" />
            <input [value]="selectedFile?.wopi?.user_id" name="user_id" type="hidden" />
          </form>

          <iframe
            [ngClass]="{
              'view-file__office-frame--open': editWopiFile,
              'view-file__office-frame--closed': !editWopiFile,
            }"
            allowfullscreen="true"
            class="view-file__office-frame"
            id="officeFrame"
            name="officeFrame"
            sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
            title="Office Frame"
          ></iframe>
        }

        @if (editWopiFile && selectedFile.wopi && selectedFile.wopi.errors) {
          <div class="view-file__wopi-errors">
            @for (error of selectedFile.wopi.errors; track error) {
              <p>
                <strong>{{ error }}</strong>
              </p>
            }
          </div>
        }

        @if (editWopiFile && !selectedFile.wopi) {
          <div class="view-file__placeholder">
            <div class="view-file__placeholder-copy">
              <h3 class="view-file__placeholder-title">{{ selectedFile.name }}</h3>
              <p>This file type cannot be edited directly in the browser.</p>
            </div>
            <div class="view-file__placeholder-actions">
              <ts-button variant="secondary" (buttonClick)="downloadDocument(selectedDocument)"
                >Download File</ts-button
              >
            </div>
          </div>
        }
      }

      @if (selectedDocument && !editWopiFile) {
        @if (!previewPdfUrl && selectedDocument.integrated_storage === 'one_drive') {
          <div class="view-file__open-online">
            <ts-button variant="primary" id="add-project-finish-button" (buttonClick)="openOnline(selectedDocument)">
              Open In Office Online
            </ts-button>
          </div>
        }
        @if (previewPdfUrl) {
          <div class="view-file__pdf">
            <iframe [src]="previewPdfUrl | safe" class="view-file__pdf-frame" id="pdf-viewer"></iframe>

            @if (selectedFile.wopi && !selectedFile.wopi.errors && !isReadonly) {
              <ts-button
                type="fab"
                color="primary"
                class="view-file__wopi-fab"
                htmlButtonType="button"
                icon="edit"
                (buttonClick)="toggleWopiFile()"
              ></ts-button>
            }
          </div>
        } @else if (selectedDocument.integrated_storage !== 'one_drive') {
          <div class="view-file__placeholder">
            <div class="view-file__placeholder-copy">
              <h3 class="view-file__placeholder-title">{{ selectedFile.name }}</h3>
              <p>This file cannot be previewed in the browser.</p>
            </div>
            <div class="view-file__placeholder-actions">
              <ts-button variant="secondary" (buttonClick)="downloadDocument(selectedDocument)"
                >Download File</ts-button
              >
            </div>
          </div>
        }
      }
    </div>

    <aside
      class="view-file__sidebar"
      [ngClass]="{
        'view-file__sidebar--expanded': expandRightSidebar,
        'view-file__sidebar--collapsed': !expandRightSidebar,
      }"
    >
      <div class="view-file__sidebar-inner">
        <div class="view-file__sidebar-header">
          <div class="view-file__sidebar-title text-secondary">
            {{ expandRightSidebar ? selectedFile.name : '' }}
          </div>
          @if (expandRightSidebar && !isReadonly) {
            <ts-button
              htmlButtonType="button"
              type="icon"
              svgIcon="delete"
              buttonTooltip="Delete file"
              (buttonClick)="deleteFile()"
            ></ts-button>
          }
          <ts-button
            htmlButtonType="button"
            type="icon"
            class="view-file__collapse"
            (buttonClick)="expandRightSidebar = !expandRightSidebar"
            [svgIcon]="expandRightSidebar ? 'chevron_left' : 'chevron_right'"
          ></ts-button>
        </div>

        <div class="view-file__sidebar-body" [ngClass]="{ hidden: !expandRightSidebar }">
          @if (tabs) {
            <ts-tab-group [tabs]="tabs" />
          }
          <ng-template #localDocsTemplate>
            <table class="view-file__table" mat-table [dataSource]="localDocumentsDataSource" [trackBy]="trackByFn">
              <ng-container matColumnDef="version">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Version</span>
                </th>
                <td mat-cell *matCellDef="let document; let i = index">
                  <div class="view-file__version text-secondary">
                    <a (click)="setSelectedDocument(document)">
                      <div class="flex flex-row">
                        <div class="view-file__version-link">
                          Version {{ localDocumentsDataSource.data.length - i }}
                        </div>
                      </div>
                    </a>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="assetable_category_label">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Category</span>
                </th>
                <td mat-cell *matCellDef="let document">
                  <span class="view-file__cell text-secondary">
                    {{ document.assetable_category_label ?? '' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="created_by">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Created By</span>
                </th>
                <td mat-cell *matCellDef="let document">
                  <span class="view-file__cell text-secondary">
                    {{ document.created_by ? document.created_by.full_name : '' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="created_at">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Date</span>
                </th>
                <td mat-cell *matCellDef="let document">
                  <span class="view-file__cell text-secondary">
                    {{ document.created_at | date: 'LLL dd, y h:mm a' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Actions</span>
                </th>
                <td mat-cell *matCellDef="let document">
                  <span class="view-file__cell text-secondary">
                    @if (!isReadonly) {
                      <ts-button
                        htmlButtonType="button"
                        type="icon"
                        class="delete-file"
                        (buttonClick)="deleteDocument(document)"
                        svgIcon="delete"
                      ></ts-button>
                    }
                    <ts-button
                      htmlButtonType="button"
                      type="icon"
                      class="icon"
                      (buttonClick)="downloadDocument(document)"
                      svgIcon="get_app"
                    ></ts-button>
                    @if (!isReadonly) {
                      <ts-button
                        htmlButtonType="button"
                        type="icon"
                        class="icon"
                        [ngClass]="{ 'edit-file': editWopiFile }"
                        (buttonClick)="toggleWopiFile()"
                        [svgIcon]="editWopiFile ? 'picture_as_pdf' : 'edit'"
                      ></ts-button>
                    }
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="documentVersionsTableFooter">
                <td class="view-file__footer-cell" mat-footer-cell *matFooterCellDef colspan="6">
                  @if (!isReadonly) {
                    <input class="hidden" type="file" (change)="onFileChanged($event)" #fileInput />
                    <ts-button type="stroked" (buttonClick)="fileInput.click()"> Upload New File Version </ts-button>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="localDocumentsColumns"></tr>
              <tr class="order-row h-16" mat-row *matRowDef="let row; columns: localDocumentsColumns"></tr>
              <tr class="py-3" mat-footer-row *matFooterRowDef="['documentVersionsTableFooter']"></tr>
            </table>
          </ng-template>

          <ng-template #integrationDocsTemplate>
            <table
              class="view-file__table"
              mat-table
              [dataSource]="integrationDocumentsDataSource"
              [trackBy]="trackByFn"
            >
              <ng-container matColumnDef="version">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Version</span>
                </th>
                <td mat-cell *matCellDef="let document; let i = index">
                  <div class="view-file__version text-secondary">
                    <a (click)="setSelectedDocument(document)">
                      <div class="flex flex-row">
                        <div class="view-file__version-link">
                          Version {{ integrationDocumentsDataSource.data.length - i }}
                        </div>
                      </div>
                    </a>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="integrated_storage">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Storage</span>
                </th>
                <td mat-cell *matCellDef="let document">
                  <span class="view-file__cell text-secondary">
                    {{ document.integrated_storage ?? '' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="created_by">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Created By</span>
                </th>
                <td mat-cell *matCellDef="let document">
                  <span class="view-file__cell text-secondary">
                    {{ document.created_by ? document.created_by.full_name : '' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="created_at">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Date</span>
                </th>
                <td mat-cell *matCellDef="let document">
                  <span class="view-file__cell text-secondary">
                    {{ document.created_at | date: 'LLL dd, y h:mm a' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th class="view-file__th" mat-header-cell *matHeaderCellDef>
                  <span class="whitespace-nowrap">Actions</span>
                </th>
                <td mat-cell *matCellDef="let document">
                  <span class="view-file__cell text-secondary">
                    <ts-button
                      htmlButtonType="button"
                      type="icon"
                      class="icon"
                      (buttonClick)="downloadDocument(document)"
                      svgIcon="get_app"
                    ></ts-button>
                  </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="integrationDocumentsColumns"></tr>
              <tr class="order-row h-16" mat-row *matRowDef="let row; columns: integrationDocumentsColumns"></tr>
            </table>
          </ng-template>
        </div>

        <div class="view-file__comments" [ngClass]="{ hidden: !expandRightSidebar }">
          <comment-view
            [relatedToId]="selectedFile.id"
            relatedToType="FileResource"
            [account]="account"
            [readonly]="isReadonly"
          ></comment-view>
        </div>
      </div>
    </aside>
  </div>
</ts-dialog>
